import BasicSelectInput from '@shared/ui/forms/inputs/BasicSelectInput';
import { RenderItemTeam } from '@shared/ui/forms/select-render';

export default function SelectNetworkInput({
  control,
  name,
  label,
  error,
  data,
  disabled,
}) {
  // const value = useWatch({
  //   control,
  //   name,
  // });

  return (
    <>
      <BasicSelectInput
        control={control}
        name={name}
        label={label}
        error={error}
        data={data}
        cleanable={false}
        disabled={disabled}
        valueKey="value"
        labelKey="label"
        isRequired={true}
        placeholder="Select currency"
        Render={RenderItemTeam}
      />
    </>
  );
}

// <FormGroup label={label} error={error}>
//   <Controller
//     control={control}
//     name={name}
//     rules={{ required: true }}
//     render={({ field }) => (
//       <InputGroup
//         inside
//         disabled={disabled}
//         className={`${field.value ? 'has-value' : ''}`}
//       >
//         <SelectPicker
//           searchable={false}
//           value={field.value}
//           data={data}
//           onChange={(value) => {
//             field.onChange(value);
//           }}
//           onClean={onClean}
//           caretAs={disabled ? 'none' : ''}
//           block
//           renderValue={(label, item) => {
//             return (
//               <RenderItemTeam
//                 item={item}
//                 icon={getCryptoName(item?.label)}
//               />
//             );
//           }}
//           renderOption={(label, item) => {
//             return (
//               <RenderItemTeam
//                 item={item}
//                 icon={getCryptoName(item?.label)}
//               />
//             );
//           }}
//         />
//       </InputGroup>
//     )}
//   />
// </FormGroup>
